import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Shown when we could not read a signed-in user's permissions.
 * We do NOT know that they lack access — so we never redirect them away.
 */
const AccessRetryBanner: React.FC<{ onRetry: () => void; retrying?: boolean }> = ({
  onRetry,
  retrying,
}) => (
  <div className="flex min-h-[60vh] items-center justify-center p-6">
    <div
      role="alert"
      data-testid="access-retry-banner"
      className="w-full max-w-md rounded-lg border border-destructive/40 bg-destructive/10 p-6 text-center"
    >
      <AlertTriangle className="mx-auto mb-3 h-6 w-6 text-destructive" />
      <p className="mb-1 font-semibold">Could not load your permissions.</p>
      <p className="mb-4 text-sm text-muted-foreground">
        You are still signed in. This is a connection problem, not an access problem.
      </p>
      <Button onClick={onRetry} disabled={retrying}>
        {retrying ? 'Retrying…' : 'Retry'}
      </Button>
    </div>
  </div>
);

export default AccessRetryBanner;
